// extracted by mini-css-extract-plugin
module.exports = {"NotificationBox":"CustomInbox_NotificationBox__2H_1Q","MessageList":"CustomInbox_MessageList__yYC2s"};